import { Button } from '@ordr-as/umami-react/button';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

const AddPaymentMethodButton = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const onClick = () => {
    const currentUrl = location.pathname;
    navigate(`${currentUrl}/settings`, { state: { backgroundLocation: location } });
  };

  return (
    <Button kind="primary" fullWidth onClick={onClick}>
      {formatMessage({ id: 'generic.addPaymentMethod' })}
    </Button>
  );
};

export default AddPaymentMethodButton;
